export default __webpack_public_path__ + "static/media/s7.b95864b3.png";